import { Component } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { themr } from '../react-css-themr'
import { SWITCH } from '../identifiers'
import rippleFactory from '../ripple/Ripple'
import thumbFactory from './Thumb'

const factory = Thumb => {
  class Switch extends Component {
    static propTypes = {
      checked: PropTypes.bool,
      className: PropTypes.string,
      disabled: PropTypes.bool,
      label: PropTypes.string,
      name: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      ripple: PropTypes.bool,
      theme: PropTypes.shape({
        disabled: PropTypes.string,
        field: PropTypes.string,
        input: PropTypes.string,
        off: PropTypes.string,
        on: PropTypes.string,
        ripple: PropTypes.string,
        text: PropTypes.string,
        thumb: PropTypes.string,
      }),
    }

    handleToggle = event => {
      const { checked = false, disabled = false, onChange } = this.props
      if (event.pageX !== 0 && event.pageY !== 0) this.blur()
      if (!disabled && onChange) {
        onChange(!checked, event)
      }
    }

    blur() {
      this.inputNode.blur()
    }

    focus() {
      this.inputNode.focus()
    }

    render() {
      const {
        checked = false,
        className = '',
        disabled = false,
        label,
        onChange,
        ripple,
        theme,
        ...others
      } = this.props
      const _className = cx(theme[disabled ? 'disabled' : 'field'], className)
      return (
        <label data-react-toolbox='switch' className={_className}>
          <input
            {...others}
            checked={checked}
            className={theme.input}
            onClick={this.handleToggle}
            readOnly
            ref={node => {
              this.inputNode = node
            }}
            type='checkbox'
          />
          <span className={theme[checked ? 'on' : 'off']}>
            <Thumb disabled={disabled} theme={theme} ripple={ripple} />
          </span>
          {label ? <span className={theme.text}>{label}</span> : null}
        </label>
      )
    }
  }

  return Switch
}

const Thumb = thumbFactory(rippleFactory({ centered: true, spread: 2.6 }))
const Switch = factory(Thumb)

export default themr(SWITCH)(Switch)
export { factory as switchFactory }
export { Switch }
